<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" vs-md="12" vs-sm="12">
      <vs-card>
        <h3 class="card-title d-flex">
          List of recent Events
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New Event</vs-button>
        </h3>
        <vs-row>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select :color="colorx" label="Language Filter" @change="fileter($event, 'language')" v-model="search.language">
              <vs-select-item value="" text="All Languages" />
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <vs-select :color="colorx" label="Sorting Type" v-model="sorting" @change="fileterusingSort($event)">
            <vs-select-item value text="Select Sorting" disabled />
            <vs-select-item value="1" text="Ascending" />
            <vs-select-item value="-1" text="Descending" />
          </vs-select>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select :color="colorx" label="Category Filter" @change="fileter($event, 'categoryId')" v-model="search.categoryId">
              <vs-select-item value="" text="All Category" />
              <vs-select-item :key="index" :value="item._id" :text="item.categoryName" v-for="(item, index) in categories" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select label="Visibility" @change="fileter($event, 'isPrivate')" v-model="search.isPrivate">
              <vs-select-item value="" text="Visibility" />
              <vs-select-item value="true" text="Private" />
              <vs-select-item value="false" text="Public" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select label="Approval Status" @change="fileter($event, 'eventStatus')" v-model="search.eventStatus">
              <vs-select-item value="" text="Approval Status" />
              <vs-select-item value="APPROVED" text="APPROVED" />
              <vs-select-item value="REJECTED" text="REJECTED" />
              <vs-select-item value="PENDING" text="PENDING" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select :color="colorx" label="Select Year" @change="fileter($event, 'year')" v-model="search.year">
              <vs-select-item value="" text="All Years" />
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in years" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="d-flex drop-width">
            <vs-select :color="colorx" label="Select Month" @change="fileter($event, 'month')" v-model="search.month">
              <vs-select-item value="" text="All Months" />
              <vs-select-item :key="index" :value="index + 1" :text="item" v-for="(item, index) in months" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" class="d-flex drop-width">
            <vs-select :color="colorx" label="Search On" @change="fileter($event, 'searchKey', false)" v-model="search.searchKey">
              <vs-select-item value text="Search On" />
              <vs-select-item value="email" text="Email" />
              <vs-select-item value="userName" text="Username" />
              <vs-select-item value="state" text="State" />
              <vs-select-item value="pincode" text="Pincode" />
              <!-- <vs-select-item value="userMob" text="Mobile Number" /> -->
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" class="d-flex">
            <vs-input icon-after="true" label-placeholder="Search by selected parameter" icon="search" v-model="searchValue" style="z-index: 0" />
          </vs-col>
          <vs-col vs-lg="2" class="d-flex">
            <vs-button color="primary" type="filled" style="z-index: 0" class="searchBtn mr5" @click="fetchAllEvents()" icon="search"
              >Search</vs-button
            >
            <vs-button color="warning" type="filled" style="z-index: 0" class="searchBtn" icon="cached" @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table" scope="col">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Image</th>
            <th @click="sortByDate('createdDate')" style="cursor: pointer">
              Created Date
              <span v-if="sortByField === 'createdDate'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th scope="col">title</th>
            <th scope="col">description</th>
            <!-- <th scope="col">Username</th> -->
            <th scope="col" @click="sortBy('eventStatus')" style="cursor: pointer">
              Event Status
              <span v-if="sortByField === 'eventStatus'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th scope="col">Language</th>
            <!-- <th scope="col">Mobile Number</th> -->
            <th scope="col"></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.name">
            <td scope="col">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
            <td scope="col">
              <img v-if="item.imageURL == '' || item.imageURL == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.imageURL" height="50px" width="75px" />
            </td>
            <td scope="col">{{ new Date(item.createdAt).toLocaleString() }}</td>
            <th scope="col">{{ item.title }}</th>
            <th scope="col" class="word-break">{{ item.description.slice(0, 300) }}...</th>
            <!-- <td scope="col">{{ item.usersId.userName }}</td> -->
            <td scope="col">
              <!-- {{ item.eventStatus }} -->
              <vs-chip v-if="item.eventStatus == 'APPROVED'" color="success">APPROVED</vs-chip>
              <vs-chip v-else-if="item.eventStatus == 'REJECTED'" color="danger">REJECTED</vs-chip>
              <vs-chip v-else color="warning">PENDING</vs-chip>
            </td>
            <td scope="col">{{ item.language }}</td>
            <!-- <td scope="col">{{ item.phone }}</td> -->

            <td class="td">
              <vs-button class="mr15" size="small" color="warning" @click="editingItem(item)">Edit</vs-button>
              <vs-button
                class="mr15"
                size="small"
                color="danger"
                @click="
                  deleteUserPopup = true;
                  itemToDelete = item;
                "
                >Delete</vs-button
              >
              <vs-button
                class="mr15"
                size="small"
                color="primary"
                v-if="item.eventStatus == 'PENDING'"
                @click="
                  eventApproval = true;
                  approvalitem = item;
                  isApprove = true;
                "
                >Approve</vs-button
              >
              <vs-button
                class="top"
                size="small"
                color="danger"
                v-if="item.eventStatus == 'PENDING'"
                @click="
                  eventApproval = true;
                  approvalitem = item;
                  isApprove = false;
                "
                >Reject</vs-button
              >
              <vs-button
                class="top"
                size="small"
                color="primary"
                @click="
                  viewUserPopup = true;
                  itemToView = item.usersId;
                "
                >Profile</vs-button
              >
            </td>
          </tr>
        </table>

        <!-- pagination -->
        <div class="pg-margin" v-if="all.length">
          <div class="pagination">
            <a class="cursor-pointer pag-arrow" @click="pageChange('previous')">&laquo;</a>
            <a class="pag-txt-arrow">{{ this.$data.pagination.current_page }} of {{ totalPages }}</a>
            <a class="cursor-pointer pag-arrow" @click="pageChange('next')">&raquo;</a>
          </div>
        </div>
        <!-- pagination -->

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Event' : 'Edit Event'" class="holamundo" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <label> Category <sub class="sub-text">*</sub></label>
              <vs-select :color="colorx" v-model="event.categoryId" icon="arrow_downward">
                <vs-select-item value text="Choose Category" disabled />
                <vs-select-item :value="item._id" :text="item.categoryName" v-for="(item, index) in categories" :key="index" />
              </vs-select>
              <br />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Email" v-model="event.email" />

              <!-- <label v-if="!isNew" label="Language"
                >User Email : {{ user.userEmail }}</label
              > -->
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label> Title <sub class="sub-text">*</sub></label>
              <vs-input type="text" v-model="event.title" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label> Description <sub class="sub-text">*</sub></label>
              <vs-textarea type="text" v-model="event.description" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb-4">
              <label> Address <sub class="sub-text">*</sub></label>
              <vs-input
                id="map"
                type="text"
                placeholder="Start typing Address"
                v-model="event.address"
              />
              <!-- <vue-google-autocomplete id="map" placeholder="Start typing Address" v-on:placechanged="getAddressData" v-model="event.address">
              </vue-google-autocomplete> -->
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <!-- <vs-input
                type="text"
                label="Username Created By"
                v-model="event.usersId.userName"
                disabled
              /> -->
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label> City <sub class="sub-text">*</sub></label>
              <vs-input type="text" v-model="event.city" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label> Taluk Name <sub class="sub-text">*</sub></label>
              <vs-input type="text" v-model="event.talukName" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label> District Name <sub class="sub-text">*</sub></label>
              <vs-input type="text" v-model="event.districtName" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label> State <sub class="sub-text">*</sub></label>
              <vs-input type="text" v-model="event.state" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Event Image <sub class="sub-text">*</sub></label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="event.imageURL">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
                  <img :src="event.imageURL" class="imgUp" height="100px" width="150px" />
                  <!-- <b v-if="fileName">File Name : {{ fileName }}</b> -->
                </vs-col>
              </div>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Attchment</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a Attchment File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, true)" />
                  </div>
                </vs-col>
                <vs-col v-if="event.attachments">
                  <div class="row">
                    <div class="mr-2" v-for="(url, index) in event.attachments" :key="index">
                      <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteattachmentImage(index)"></vs-button>
                      <img
                        :src="url.fileurl"
                        class="imgUp"
                        height="100px"
                        width="150px"
                        v-if="url.filetype == 'image/jpeg' || url.filetype == 'image/png' || url.filetype == 'image/jpg'"
                      />
                      <vs-icon icon="assignment" @click="openDoc(url.fileurl)" v-if="url.filetype == 'application/pdf'" class="icon-medium pointer">
                      </vs-icon>
                      <audio controls v-if="url.filetype == 'audio/mpeg'">
                        <source :src="url.url" type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                  </div>
                </vs-col>
              </div>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="User Limit" v-model="event.userLimit" :min="1" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.isRecurring">isRecurring</vs-checkbox>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.feature">Feature Event</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom" v-if="event.feature">
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.alltime">All time</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.district">District</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.taluk">Taluk</vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="3" class="mt-4 p-bottom">
                <vs-checkbox v-model="event.town">Town</vs-checkbox>
              </vs-col>
            </vs-col>
            <!-- <vs-select
              :color="colorx"
              label="Recurring Type"
              v-model="event.recurringTime"
            >
              <vs-select-item value text="Recurring Type" />
              <vs-select-item value="daily" text="daily" />
              <vs-select-item value="weekly" text="weekly" />
              <vs-select-item value="monthly" text="monthly" />
              <vs-select-item value="yearly" text="yearly" />
            </vs-select> -->

            <!-- <vs-col vs-lg="6" vs-xs="6" class="mt-4 p-bottom">
              <vs-select
                :color="colorx"
                label="Recurring Type"
                v-model="event.recurringTime"
                icon="arrow_downward"
              >
                <vs-select-item value text="Recurring Type" />
                <vs-select-item value="daily" text="daily" />
                <vs-select-item value="weekly" text="weekly" />
                <vs-select-item value="monthly" text="monthly" />
                <vs-select-item value="yearly" text="yearly" />
              </vs-select>
              <br />
            </vs-col> -->

            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Longitude" v-model="event.location.coordinates[0]" class="hideInput" />
              <vs-input type="number" label="Latitude" v-model="event.location.coordinates[1]" class="hideInput" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="pincode" v-model="event.pincode" class="hideInput" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Phone Number" v-model="event.phone" class="hideInput" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="text" label="Duration" v-model="event.duration" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              Event created date :
              {{ new Date(event.createdAt).toLocaleString() }}
              <!-- <datepicker
                placeholder="Event created date"
                v-model="event.createdAt"
                id="start_date"
                format="yyyy-MM-dd"
                input-class="form-group"
                @selected="dateSelected($event)"
              ></datepicker> -->
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.isPrivate">isPrivate</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4 p-bottom">
              <vs-checkbox v-model="event.status">Status</vs-checkbox>
              <br />
            </vs-col>
            <vs-col vs-lg="11" vs-xs="11" class="mb15 mt20">
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Event Start Date*</label>
                <br />
                <datepicker
                  placeholder="Start Date"
                  v-model="event.startDate"
                  id="start_date"
                  format="yyyy-MM-dd"
                  input-class="form-group"
                  :open-date="new Date()"
                  @selected="dateSelected($event)"
                ></datepicker>
              </vs-col>
              <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                <label>Event End Date*</label>
                <br />
                <datepicker
                  placeholder="End Date"
                  v-model="event.endDate"
                  format="yyyy-MM-dd"
                  input-class="form-group"
                  :open-date="new Date()"
                ></datepicker>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="11" vs-xs="11" class="mb15 mt20">
              <div>
                <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                  <label>Event Start Time*</label>
                  <br />
                  <vue-timepicker v-model="event.startTime"></vue-timepicker>
                </vs-col>
                <vs-col class="mt-6" vs-lg="6" vs-xs="6">
                  <label>Event End Time*</label>
                  <br />
                  <vue-timepicker v-model="event.endTime"></vue-timepicker>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddEvent">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- Code -->
        <vs-popup class="holamundo" title="Delete Event" :active.sync="deleteUserPopup">
          <p>Are you sure you want to delete this Event?</p>
          <div>
            <vs-button class="mr15" @click="deleteUser">Delete Event</vs-button>
            <vs-button @click="deleteUserPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <vs-popup class="holamundo" :title="isApprove ? 'Event Approval' : 'Event Rejection'" :active.sync="eventApproval">
          <p v-if="isApprove">Are you sure you want to Approve {{ approvalitem.title }} Event?</p>
          <p v-else>Are you sure you want to Reject {{ approvalitem.title }} Event?</p>
          <div>
            <vs-button class="mr15" @click="eventApprovalFunction">Confirm</vs-button>
            <vs-button @click="eventApproval = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- User Modal-->
        <vs-popup class="holamundo user-info" title="View User" :active.sync="viewUserPopup" fullscreen>
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              User Information
              <div class="mt-4">
                <img
                  v-if="itemToView.imageURL == '' || itemToView.imageURL == null"
                  src="../../../assets/images/No-image.png"
                  height="50px"
                  width="75px"
                />
                <img v-else :src="itemToView.imageURL" height="50px" width="75px" />
                <br />

                <label> {{ itemToView.userName }}</label
                ><br />
                <label>{{ itemToView.firstName }} {{ itemToView.lastName }}</label
                ><br />
                <label>FacebookId : {{ itemToView.facebookId }}</label
                ><br />
                <label>Mobile Number : {{ itemToView.userMob }}</label
                ><br />
                <label>Email : {{ itemToView.userEmail }}</label
                ><br />
              </div>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              User Address
              <div class="mt-4">
                <label>City : {{ itemToView.city }}</label
                ><br />
                <label>Country : {{ itemToView.country }}</label
                ><br />
                <label>Birth Date :{{ new Date(itemToView.birthday).toLocaleString() }} </label><br />
                <label>isBanned : {{ itemToView.isBanned }}</label
                ><br />
                <label>isVerified : {{ itemToView.isVerified }}</label
                ><br />
                <label>isPrivateProfile : {{ itemToView.isPrivateProfile }}</label
                ><br />
                <label>VIP User : {{ itemToView.vipUser }}</label>
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import Datepicker from "vuejs-datepicker";
import { API } from "@/common/constants";
import "vue2-datepicker/index.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { min } from "moment";
import axios from "axios";

// import router from "@/router.js";
export default {
  name: "Events",
  components: {
    // uploader,
    Datepicker,
    // DatePicker,
    VueTimepicker,
    VueGoogleAutocomplete,
  },
  data: () => ({
    colorx: "#0D2144",
    EventData: [],
    admin: {
      type: "USER",
    },
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    viewPopup: false,
    all: [],
    addAdmin: false,
    searchValue: "",
    languages: [],
    categories: [],
    years: [],
    isNew: true,
    defaultalert: false,
    deleteUserPopup: false,
    eventApproval: false,
    isApprove: false,
    pagination: {},
    currentPage: 1,
    pageSize: 10,
    sortByField: "",
    sortDirection: "asc",
    totalPages: 1,
    sorting: -1,
    search: {
      sort: 1,
      language: "EN",
      status: "0",
      language: "",
      isPrivate: "",
      isVerified: "",
      searchKey: "",
      categoryId: "",
      eventStatus: "",
      year: "",
      month: "",
    },
    event: {
      email: "",
      language: "",
      title: "",
      description: "",
      phone: "",
      name: "",
      city: "",
      talukName: "",
      districtName: "",
      country: "",
      imageURL: "",
      categoryId: "",
      location: { type: "Point", coordinates: [] },
      startTime: "",
      endTime: "",
      usersId: "",
      address: "",
      attachments: [],
      feature: false,
      alltime: false,
      district: false,
      taluk: false,
      town: false,
      isRecurring: true,
    },
    itemToDelete: "",
    approvalitem: "",
    itemToView: "",
    viewUserPopup: false,
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiY2FsZW5kYXJhZG1pbiIsImlhdCI6MTYxMDE4MzU4Nn0.2Atr6Dtz47BauSGsbzNF5M-V8u-0nOgDi5UDeDpvtoE",
  }),
  computed: {
    sortedData() {
      if (this.sortByField) {
        return this.all.sort((a, b) => {
          if (this.sortDirection === "desc") {
            return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
          } else {
            return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
          }
        });
      }
      return this.all;
    },
  },
  methods: {
    sortByDate(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.fileterusingSort(this.sortDirection);
    },
    sortBy(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },

    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    getAddressData(data) {
      if (document.getElementById("map")) {
        this.$data.event.address = document.getElementById("map").value;
      }
      // this.$data.event.address = data.street_number
      //   ? data.street_number
      //   : data.route;
      this.$data.event.location.coordinates = [data.longitude, data.latitude];
      this.$data.event.pincode = data.postal_code ? data.postal_code : "";
      this.$data.event.city = data.locality ? data.locality : data.administrative_area_level_2;
      this.$data.event.state = data.administrative_area_level_1;
    },
    deleteImage() {
      this.$data.fileName = "";
      this.$data.event.imageURL = "";
    },
    deleteattachmentImage(item) {
      if (item > -1) {
        this.$data.event.attachments.splice(item, 1);
      }
    },
    uploadImage(data, attachments = false) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.error != null) {
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            if (!attachments) {
              console.log("response.data.files[0].url", response.data.files[0].url);
              this.$data.event.imageURL = response.data.files[0].url;
            } else {
              this.$data.event.attachments.push({
                filetype: response.data.files[0].fileType,
                fileurl: response.data.files[0].url,
              });
            }

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            console.log(this.$data.event);
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    fetchAllCategory() {
      this.$vs.loading();
      api
        .get(API.GET_EVENT_CAT, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.categories = r.data;
        })
        .catch(() => {});
    },
    fileterusingSort(event) {
      this.$data.sorting = event;
      this.fetchAllEvents(this.$data.currentPage);
    },
    fileter(event, param, flag = true) {
      console.log(event, param, flag);
      this.$data.search[param] = event;
      this.$data.currentPage = 1;
      if (flag) {
        this.fetchAllEvents(this.$data.currentPage);
      }
    },
    fetchAllEvents(page) {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      console.log(this.$data.search);
      api
        .get(API.GET_EVENT, {
          headers,
          params: {
            pageNumber: page,
            pageSize: this.$data.pageSize,
            sort: this.$data.search.sort,
            language: this.$data.search.language,
            searchKey: this.$data.search.searchKey,
            searchValue: this.$data.searchValue,
            categoryId: this.$data.search.categoryId,
            isPrivate: this.$data.search.isPrivate,
            status: this.$data.search.status,
            sortOrder: this.$data.sorting,
            eventStatus: this.$data.search.eventStatus,
            year: this.$data.search.year,
            month: this.$data.search.month,
            sortBy: "createdAt",
          },
          // params: {
          //   language: this.$data.search.language,
          //   pageSize: this.$data.pageSize,
          //   pageNumber: page,
          // },
        })
        .then((r) => {
          if (!r.data.data.data.length) {
            this.$data.all = r.data.data.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Data Not Found",
              text: "No Record Found",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.loading.close();
            this.$data.all = r.data.data.data;
            console.log("Fetched");
            console.log("Edit Event Data", this.EventData);
            if (this.EventData && Object.keys(this.EventData).length > 0) {
              this.all[0] = this.EventData;
            }
            console.log("Add Data", this.$data.all);
            if (this.$route.query.edit === "true") {
              const targetId = this.$route.query.id;
              const targetItem = this.all.find((item) => item._id === targetId);
              if (targetItem) {
                this.editingItem(targetItem, "edit");
              }
            }
            this.$data.pagination = r.data.data.meta.pagination;
            this.$data.totalPages = r.data.data.meta.pagination.total_pages;
          }
        })
        .catch(() => {});
    },
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.displayImage = "";
      this.$data.event = {
        email: "",
        language: "",
        title: "",
        description: "",
        phone: "",
        name: "",
        city: "",
        country: "",
        imageURL: "",
        categoryId: "",
        location: { type: "Point", coordinates: [] },
        startTime: "",
        endTime: "",
        usersId: "",
        address: "",
        attachments: [],
        feature: false,
        alltime: false,
        district: false,
        taluk: false,
        town: false,
        talukName: "",
        districtName: "",
      };
    },
    btnAddEvent() {
      if (
        !this.$data.event.endDate ||
        !this.$data.event.startDate ||
        !this.$data.event.title ||
        !this.$data.event.description ||
        !this.$data.event.endTime ||
        !this.$data.event.startTime ||
        !this.$data.event.categoryId ||
        // !this.$data.event.imageURL ||
        !this.$data.event.city ||
        !this.$data.event.talukName ||
        !this.$data.event.districtName
      ) {
        this.$vs.notify({
          text: "Please enter all the details",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      // this.$data.event.address =
      //   this.$data.event.city +
      //   ", " +
      //   this.$data.event.talukName +
      //   ", " +
      //   this.$data.event.districtName +
      //   ", " +
      //   this.$data.event.state +
      //   ", " +
      //   this.$data.event.country;

      this.$data.event.usersId = JSON.parse(localStorage.user)._id;

      const findCategory = this.$data.categories.find((item) => item._id === this.$data.event.categoryId);
      this.$data.event.language = this.$data.search.language ? this.$data.search.language : findCategory.language;

      this.$data.event.location.coordinates[0] = parseFloat(this.$data.event.location.coordinates[0]);
      this.$data.event.location.coordinates[1] = parseFloat(this.$data.event.location.coordinates[1]);
      if (!this.$data.isNew) {
        // if (this.$data.user.userEmail == "") {
        //   this.$vs.notify({
        //     text: "User Email Require",
        //     color: "warning",
        //     position: "top-right",
        //   });
        //   return;
        // }
        if (typeof this.$data.event.startTime == "object") {
          this.$data.event.startTime = this.$data.event.startTime.hh + ":" + this.$data.event.startTime.mm;
        }
        if (typeof this.$data.event.endTime == "object") {
          this.$data.event.endTime = this.$data.event.endTime.hh + ":" + this.$data.event.endTime.mm;
        }

        let date = new Date(this.$data.event.startDate);
        let eDate = new Date(this.$data.event.endDate);

        if (this.$data.event.startDate) {
          this.$data.event.startDate = date.getFullYear() + "/" + this.padTo2Digits(date.getMonth() + 1) + "/" + this.padTo2Digits(date.getDate());
        }

        if (this.$data.event.endDate) {
          this.$data.event.endDate = eDate.getFullYear() + "/" + this.padTo2Digits(eDate.getMonth() + 1) + "/" + this.padTo2Digits(eDate.getDate());
        }

        // if (this.$data.event.language == "") {
        //   this.$vs.notify({
        //     text: "Language Require",
        //     color: "warning",
        //     position: "top-right",
        //   });
        //   return;
        // }
        this.btnUpdateEvent();
      } else {
        let data = this.$data.event;
        let fieldName = "";
        if (data.language == "") {
          fieldName = "Language";
        }
        if (data.email == "") {
          this.$vs.notify({
            text: fieldName + " Require",
            color: "warning",
            position: "top-right",
          });
          return;
        }
        // this.$vs.loading();
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        if (!data.feature) {
          data.alltime = false;
          data.district = false;
          data.taluk = false;
          data.town = false;
        } else {
          if (!data.alltime && !data.district && !data.taluk && !data.town) {
            this.$vs.notify({
              text: "Please select feature type",
              color: "danger",
              position: "top-right",
            });
            return;
          }
        }
        this.$vs.loading();
        api
          .post(API.GET_EVENT, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (r.data.status) {
              this.$vs.notify({
                text: "Saved Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              (this.$data.event = {
                email: "",
                language: "",
                title: "",
                description: "",
                phone: "",
                name: "",
                city: "",
                country: "",
                imageURL: "",
                categoryId: "",
                location: { type: "Point", coordinates: [] },
                startTime: "",
                endTime: "",
                usersId: "",
                eventStatus: "",
                address: "",
                attachments: [],
                feature: false,
                alltime: false,
                district: false,
                taluk: false,
                town: false,
                talukName: "",
                districtName: "",
              }),
                this.fetchAllEvents(this.$data.currentPage);
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    editingItem(i) {
      // let eDate = new Date(i.endDate);
      // i.endDate =
      //   eDate.getFullYear() +
      //     "/" +
      //     (eDate.getMonth() + 1) +
      //     "/" +
      //     eDate.getDate()
      this.$data.event = Object.assign({}, i);
      if (i.categoryId && i.categoryId._id) this.$data.event["categoryId"] = i.categoryId._id;
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },
    btnUpdateEvent() {
      if (this.$route.query.id) {
        this.$router.replace({ path: "/events", query: { id: this.$route.query.id, edit: "false" } });
      }
      if (
        !this.$data.event.endDate ||
        !this.$data.event.startDate ||
        !this.$data.event.title ||
        !this.$data.event.description ||
        !this.$data.event.address ||
        !this.$data.event.endTime ||
        !this.$data.event.startTime ||
        !this.$data.event.categoryId ||
        // !this.$data.event.imageURL ||
        !this.$data.event.city ||
        !this.$data.event.talukName ||
        !this.$data.event.districtName
      ) {
        this.$vs.notify({
          text: "Please enter all the details",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      // this.$data.event.address =
      //   this.$data.event.city +
      //   ", " +
      //   this.$data.event.talukName +
      //   ", " +
      //   this.$data.event.districtName +
      //   ", " +
      //   this.$data.event.state +
      //   ", " +
      //   this.$data.event.country;

      let data = this.$data.event;
      this.$data.event.location.coordinates[0] = parseFloat(this.$data.event.location.coordinates[0]);
      this.$data.event.location.coordinates[1] = parseFloat(this.$data.event.location.coordinates[1]);
      if (data.startDate) {
        let date = new Date(data.startDate);
        data.startDate = date.getFullYear() + "-" + this.padTo2Digits(date.getMonth() + 1) + "-" + this.padTo2Digits(date.getDate());
      }

      if (data.endDate) {
        let date = new Date(data.endDate);
        data.endDate = date.getFullYear() + "-" + this.padTo2Digits(date.getMonth() + 1) + "-" + this.padTo2Digits(date.getDate());
      }
      let id = this.$data.event._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      if (!data.feature) {
        data.alltime = false;
        data.district = false;
        data.taluk = false;
        data.town = false;
      } else {
        if (!data.alltime && !data.district && !data.taluk && !data.town) {
          this.$vs.notify({
            text: "Please select feature type",
            color: "danger",
            position: "top-right",
          });
          return;
        }
      }
      this.$vs.loading();
      api
        .put(API.GET_EVENT, data, { headers, params: { id: id } })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.event = {
              email: "",
              language: "",
              title: "",
              description: "",
              phone: "",
              name: "",
              city: "",
              country: "",
              imageURL: "",
              categoryId: "",
              location: { type: "Point", coordinates: [] },
              startTime: "",
              endTime: "",
              usersId: "",
              eventStatus: "",
              address: "",
              attachments: [],
              feature: false,
              alltime: false,
              district: false,
              taluk: false,
              town: false,
              talukName: "",
              districtName: "",
            };
            if (this.$route.query.id) {
              this.fetchEvent(this.$route.query.id);
            }
            this.fetchAllEvents(this.$data.currentPage);
            if (this.$route.query.id && this.$route.query.edit === "false") {
              this.$router.push({ path: "/calendar" });
            }
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    deleteUser() {
      let id = this.$data.itemToDelete._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .delete(API.GET_EVENT, { headers, params: { id: id } })
        .then((r) => {
          if (r.status == 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteUserPopup = false;
          this.fetchAllEvents(this.$data.currentPage);
        })
        .catch(() => {});
    },
    eventApprovalFunction() {
      let id = this.$data.approvalitem._id;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      api
        .post(
          API.GET_EVENT + "/review",
          {
            eventStatus: this.$data.isApprove ? "APPROVED" : "REJECTED",
            id: id,
          },
          { headers }
        )
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.eventApproval = false;
            this.$data.approvalitem = "";
            this.fetchAllEvents(this.$data.currentPage);
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    pageChange(event) {
      if (event == "previous") {
        if (this.$data.currentPage <= 1) {
          return;
        } else {
          this.$data.currentPage--;
          this.fetchAllEvents(this.$data.currentPage);
        }
      } else {
        if (this.$data.currentPage == this.$data.totalPages) {
          return;
        } else {
          this.$data.currentPage++;
          this.fetchAllEvents(this.$data.currentPage);
        }
      }
    },
    dateSelected(e) {
      // this.$data.event.joinDate = e;
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    resetData() {
      this.$data.search = {
        sort: 1,
        // language: "EN",
        status: "0",
        language: "",
        isBanned: "",
        isVerified: "",
        searchKey: "",
        categoryId: "",
        isPrivate: "",
        sorting: -1,
        eventStatus: "",
        year: "",
        month: "",
      };
      this.$data.searchValue = "";
      this.fetchAllEvents();
    },
    openDoc(url) {
      window.open(url, "_blank");
    },
    cloneEventModal() {
      this.$data.viewUserPopup = true;
    },
    async fetchEvent(id) {
      try {
        const response = await api.get(`${API.SOCIAL_EVENTS}/${id}`, {
          headers: {
            "Content-Type": "application/json",
            api_key: "anvl_bharat_cal123"
          }
        });
        this.EventData = response.data;
        console.log("Event data:", this.EventData);
      } catch (error) {
        console.error("Failed to fetch panchang:", error);
      }
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.fetchEvent(this.$route.query.id);
    }
  },
  watch: {},
  created() {
    this.fetchAllLanguages();
    this.fetchAllEvents(this.$data.currentPage);
    this.fetchAllCategory();
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year > 2020; year--) {
      this.$data.years.push(year);
    }
  },
};
</script>

<style scoped>
.leftHead h4 {
  font-size: 14px;
  font-weight: 600;
}

.rightHead h5 {
  font-size: 14px;
  font-weight: 400;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.top {
  margin-top: 10px;
}

.searchBtn {
  margin-top: 25px;
  width: 50%;
}

.mr15 {
  margin-right: 10px;
}

.mr5 {
  margin-right: 5px;
}

.pg-margin {
  margin-left: 80%;
}

.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}

.pag-arrow {
  color: #44a8ff !important;
  font-size: 20px;
}

.pag-txt-arrow {
  font-size: 15px;
  margin-top: 5px;
}

.drop-width {
  width: 150px !important;
}

.word-break {
  word-break: break-all;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.modalOpenCss {
  z-index: 1 !important;
  padding-top: 30px;
}

.pac-target-input {
  width: 100% !important;
  padding: 5px !important;
}

.sub-text {
  color: red;
  font-size: 12px;
}

.pointer {
  cursor: pointer;
}

.hideInput ::v-deep input[type="number"]::-webkit-outer-spin-button,
.hideInput ::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.hideInput ::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>
